/**
 * Defines the kind of contextual sources for node rewards
 */
export enum RewardGraphContextualSources {
    /** None */
    None = 0x0000,
}
